<div class="col-12 booking-details marg-0 col-nopad-sm">
  <!-- <div class="col-12"> -->
    <!-- <button pButton class="assign-btn" type="button" [label]="labelBack" icon="fa-arrow-left" (click)="onClickBack()"></button> -->
  <!-- </div> -->
  <div class="grid col-12 panel-div booking-details-header" style="box-shadow: 1px 1px 1px #aaaaaa;">
    <div class="col-12 pb-0 c-mb-n20">
      <app-page-header *ngIf="notificationService.canFetchNotification" [getUrl]="sendUrl"></app-page-header>
</div>
    <div class="col-12 md:col-8 lg:col-9 pl-0">
      <div class="trip-id c-ml-0">
        <span translate>label_tripID</span>
        <span> : {{tourBookingInfo !== null ? tourBookingInfo.tripId : ''}}</span>
      </div>
      <div class="trip-time">
        <span>{{(tourBookingInfo !== null ? tourBookingInfo.createdAt : '')| datetimeformat}}</span>
        <span class="c-ml-5">|</span>
        <i class="fa fa-car"></i>
        <span> {{vehicleInfo !== null ? vehicleInfo.vehicleType : ''}}</span>
      </div>
      <div *ngIf="tourBookingInfo !== null" class="trip-status">
        <span class="key" translate>label_booking_type</span>
        <span class="key"> : {{tourBookingInfo !== null ? tourBookingInfo.rideType : '-'}}</span>
      </div>
      <div *ngIf="tourBookingInfo !== null && tourBookingInfo.rideLater" class="trip-status">
        <span class="key" translate>label_ride_schedule_at</span>
        <span class="key"> : </span>
        <span class="key">{{(tourBookingInfo.rideLaterPickupTime !== null ? tourBookingInfo.rideLaterPickupTime : '')|
          datetimeformat}}</span>
      </div>
      <!-- <div class="trip-status">
        <span class="key" translate>label_booking_status</span>
        <span class="value"> {{tourBookingInfo !== null ? tourBookingInfo.tourStatusString : ''}}</span>
      </div> -->
      <div class="trip-status">
        <span class="key" translate>label_booking_status</span>
        <span class="key"> : </span>
        <span class="value">{{tourBookingInfo !== null ? tourBookingInfo.tourStatusString : ''}}</span>
        <span class="value" *ngIf="tourBookingInfo?.tourStatusString === 'Cancelled'"> by
          {{tourBookingInfo.cancelledByUser | lowercase}}</span>
      </div>
      <div *ngIf="tourBookingInfo !== null && tourBookingInfo.cancellationReason !== '' && tourBookingInfo.cancellationReason !== null" class="trip-status">
        <span class="key" translate>label_cancellation_reason</span>
        <span class="key"> : </span>
        <span class="key">{{tourBookingInfo.cancellationReason}}</span>
      </div>
      <div class="trip-status" *ngIf="tripNote && tourBookingInfo?.tripNote!==null &&tourBookingInfo?.tripNote">
        <span class="key" translate>label_trip_note</span>
        <span class="key"> : </span>
        <span class="key"> {{tourBookingInfo.tripNote}}</span>
      </div>
    </div>


    <div class="col-3 md:col-3 lg:col-3 pt-2 amount" *ngIf="invoiceInfo && invoiceInfo?.id">
      {{invoiceInfo !== null && invoiceInfo.id? invoiceInfo?.grandTotalString : ''}}
    </div>
    <div class="col-3 md:col-3 lg:col-3 pt-2 amount" *ngIf="invoiceInfo && !invoiceInfo?.id">
     {{ (tourBookingInfo.tourStatus !== cancelledTrip && tourBookingInfo?.tourStatus !== expiredTrip)? estimatesInfo.grandTotalString : ''}}
    </div>

    <!-- <div class="ui-g-3 ui-md-3 ui-lg-3 amount">
       <div *ngIf="!fareBreakDown">
          {{ estimatesInfo !== null ? estimatesInfo.grandTotalString : ''}}
        </div>
        <div *ngIf="fareBreakDown">
          <div *ngFor="let fare of fareBreakDown;">
            <div *ngIf="fare.key === 'Grand total'">
              {{ fare.value }}
            </div>
          </div>
        </div>
    </div> -->
  </div>

  <div class="grid col-12 md:col-12 lg:col-12 panel-div address-container" style="margin-top: 10px;box-shadow: 1px 1px 1px #aaaaaa;">
    <div class="col-12 md:col-12 lg:col-6">
      <div class="grid col-12 md:col-12 lg:col-12" style="height: 125px;">
        <div class="col-1 md:col-1 lg:col-1">
          <div class="start-point"></div>
          <div [ngClass]="(tourBookingInfo && tourBookingInfo?.pickupTime) && (tourBookingInfo && tourBookingInfo?.dropTime) ? 'divider-time-display' : 'divider'">
        </div>
        </div>
        <div class="col-11 md:col-11 lg:col-11">
          <!-- <div class="time" >{{tourBookingInfo !== null ? (tourBookingInfo.pickupTime | minutsformat) : '--:--'}}</div>  -->
          <p class="time" *ngIf="tourBookingInfo && tourBookingInfo?.pickupTime">{{tourBookingInfo.tourStatus === completedBookingStatus ? (tourBookingInfo.pickupTime | minutsformat) : ' '}}</p>
          <div>{{tourBookingInfo !== null ? tourBookingInfo.pickupLocationName : ''}}</div>
        </div>
      </div>

      <div class="grid col-12 md:col-12 lg:col-12" style="height: 125px;">
        <div class="col-1 md:col-1 lg:col-1">
          <div [ngClass]="(tourBookingInfo && tourBookingInfo?.pickupTime) && (tourBookingInfo && tourBookingInfo?.dropTime) ? 'end-point-time-diplay' : 'end-point'"></div>
        </div>

        <div class="col-11 md:col-11 lg:col-11">
            <p class="time" *ngIf="tourBookingInfo && tourBookingInfo?.dropTime">{{tourBookingInfo.tourStatus === completedBookingStatus ? (tourBookingInfo.dropTime | minutsformat) : ' '}}</p>
            <div>{{tourBookingInfo !== null  && tourBookingInfo.dropLocationName? tourBookingInfo.dropLocationName : 'Destination not available'}}</div>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6" *ngIf="routeImageUrl === null">
      <div class="col-12 md:col-12 lg:col-12" style="padding: 0 0 10px 0;">
        <button type="button" (click)="viewMap()" [disabled]="isViewMap" pButton label="View Map"></button>
      </div>
      <div id="tripMap" style="width: 100%;height: 250px;" *ngIf="mapView"></div>
      <!-- <h3 translate *ngIf="!mapView" style="text-align: center;padding-top: 80px;">label_no_route_available</h3> -->
    </div>

    <div *ngIf="routeImageUrl !== null" class="col-12 md:col-12 lg:col-4">
        <img style="width: 250px;height: 250px;" src="{{routeImageUrl}}">
    </div>
  </div>

  <div class="grid col-12 md:col-12 lg:col-12 panel-div booking-detail-container" style="margin-top: 10px;box-shadow: 1px 1px 1px #aaaaaa;">
    <div class="col-12 md:col-12 lg:col-6">
      <div class="col-12 md:col-12 lg:col-12 header">
        <span translate>label_rider_details</span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <table>
          <tbody>
            <tr>
              <td class="key" translate>label_name</td>
              <td style="width: 10%;">-</td>
              <td class = "word-break">{{passengerInfo !== null ? passengerInfo.firstName: ''}} {{passengerInfo !== null ?
                passengerInfo.lastName:
                ''}}
              </td>
            </tr>
            <tr>
              <td class="key" translate>label_phone_no</td>
              <td style="width: 10%;">-</td>
              <td class = "word-break">{{passengerInfo !== null ? passengerInfo.numCountryCode : ''}} - {{passengerInfo !== null ?
                passengerInfo.phoneNum
                : ''}}</td>
            </tr>
            <tr>
              <td class="key" translate>label_email_id</td>
              <td style="width: 10%;">-</td>
              <td class = "word-break">{{passengerInfo !== null ? passengerInfo.email : ''}}</td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="col-12 md:col-12 lg:col-12 rating" *ngIf="invoiceInfo && invoiceInfo?.id">
        <div class="col-12 md:col-12 lg:col-12 rating-header">
          <span translate>label_rating_given_by_driver</span>
        </div>

        <div class="col-12 md:col-12 lg:col-12 rating-container">
          <div class="rating-stars">
            <span *ngFor="let star of maxRating;let idx = index">
              <i *ngIf="(idx + 1) <= (tourBookingInfo === null ? 0 : tourBookingInfo.driverRating)" class="fa fa-star active"></i>
              <i *ngIf="(idx + 1) > (tourBookingInfo === null ? 0 : tourBookingInfo.driverRating)" class="fa fa-star"></i>
            </span>
          </div>

          <div class="rating-comments">
            {{tourBookingInfo !== null ? tourBookingInfo.driverComment : ''}}
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-6">
      <div class="col-12 md:col-12 lg:col-12 header">
        <span translate>label_driver_details_header</span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <table>
          <tbody>
            <tr>
              <td class="key" translate>label_name</td>
              <td style="width: 10%;">-</td>
              <td class = "word-break">{{driverInfo !== null ? driverInfo.firstName: ''}} {{driverInfo !== null ? driverInfo.lastName: ''}}</td>
            </tr>
            <tr>
              <td class="key" translate>label_phone_no</td>
              <td style="width: 10%;">-</td>
              <td class = "word-break">{{driverInfo !== null ? driverInfo.numCountryCode: ''}} - {{driverInfo !== null ?
                driverInfo.phoneNum: ''}}
              </td>
            </tr>
            <tr>
              <td class="key" translate>label_email_id</td>
              <td style="width: 10%;">-</td>
              <td class = "word-break">{{driverInfo !== null ? driverInfo.email: ''}}</td>
            </tr>
          </tbody>
        </table>
      </div>


      <div class="col-12 md:col-12 lg:col-12 rating" *ngIf="invoiceInfo && invoiceInfo?.id">
        <div class="col-12 md:col-12 lg:col-12 rating-header">
          <span translate>label_rating_given_by_passenger</span>
        </div>

        <div class="col-12 md:col-12 lg:col-12 rating-container">
          <div class="rating-stars">
            <span *ngFor="let star of maxRating;let idx = index">
              <i *ngIf="(idx + 1) <= (tourBookingInfo === null ? 0 : tourBookingInfo.passengerRating)" class="fa fa-star active"></i>
              <i *ngIf="(idx + 1) > (tourBookingInfo === null ? 0 : tourBookingInfo.passengerRating)" class="fa fa-star"></i>
            </span>
          </div>

          <div class="rating-comments">
            {{tourBookingInfo !== null ? tourBookingInfo.passengerComment : ''}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid col-12 md:col-12 lg:col-12 panel-div booking-detail-container"  *ngIf="fareBreakDown" style="margin-top: 10px;box-shadow: 1px 1px 1px #aaaaaa;">

    <div class="grid col-12-md-12 lg:col-4">
      <div class="col-12 md:col-12 lg:col-12 header">
        <span translate>label_fare_details</span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <table>
          <tbody>
            <tr *ngFor="let fare of fareBreakDown;">
              <td *ngIf="fare.highlight === true" class="statistic-key-highlight">{{fare.key}}</td>
              <td *ngIf="fare.highlight === false" class="statistic-key">{{fare.key}}</td>
              <td style="width: 10%;">-</td>
              <td *ngIf="fare.highlight === true" class="statistic-key-highlight">{{fare.value}}</td>
              <td *ngIf="fare.highlight === false">{{fare.value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-4" *ngIf="tripStatistics">
      <div class="col-12 md:col-12 lg:col-12 header">
        <span translate>label_trip_statistics</span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <table>
          <tbody>
            <tr *ngFor="let statistic of tripStatistics;">
              <td *ngIf="statistic.highlight === true" class="statistic-key-highlight">{{statistic.key}}</td>
              <td *ngIf="statistic.highlight === false" class="statistic-key">{{statistic.key}}</td>
              <td style="width: 10%;">-</td>
              <td *ngIf="statistic.highlight === true" class="statistic-key-highlight">{{statistic.value}}</td>
              <td *ngIf="statistic.highlight === false">{{statistic.value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="col-12 md:col-12 lg:col-4" *ngIf="tripDetailsInfo">
      <div class="col-12 md:col-12 lg:col-12 header">
        <span translate>label_trip_details</span>
      </div>
      <div class="col-12 md:col-12 lg:col-12">
        <table>
          <tbody>
            <tr *ngFor="let detail of tripDetailsInfo;">
              <td *ngIf="detail.highlight === true" class="statistic-key-highlight">{{detail.key}}</td>
              <td *ngIf="detail.highlight === false" class="statistic-key">{{detail.key}}</td>
              <td style="width: 10%;">-</td>
              <td *ngIf="detail.highlight === true" class="statistic-key-highlight">{{detail.value}}</td>
              <td *ngIf="detail.highlight === false">{{detail.value}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>

  <div *ngIf="biddings.length > 0" class="col-12 md:col-12 lg:col-12 panel-div booking-detail-container" style="margin-top: 10px;box-shadow: 1px 1px 1px #AAA;">
    <div class="col-12 md:col-12 lg:col-12 header" style="margin-bottom:15px;">
      <span translate>label_bidding_details</span>
    </div>
    <table class="bidding-detail-container">
      <tr>
        <th translate>label_driver_name</th>
        <th translate>label_company</th>
        <th translate>label_bid_amount</th>
        <th translate>label_date_and_time</th>
        <th translate>label_driver_status</th>
        <th translate>label_passenger_status</th>
      </tr>

      <tbody *ngFor="let bid of biddings; let idx=index">
        <tr *ngIf="idx % 2 !== 0" class="odd">
          <td>{{bid.driverName}}</td>
          <td>{{bid.companyName}}</td>
          <td>{{bid.bidAmountStr}}</td>
          <td>{{bid.requestAssignedAt | datetimeformat}}</td>
          <td style="color:green;font-weight: bold;" *ngIf="bid.driverStatusStr === 'Accepted'">{{bid.driverStatusStr}}</td>
          <td style="color:red;font-weight: bold;" *ngIf="bid.driverStatusStr !== 'Accepted'">{{bid.driverStatusStr}}</td>
          <td style="color:green;font-weight: bold;" *ngIf="bid.passengerStatus === 'Accepted'">{{bid.passengerStatus}}</td>
          <td style="color:red;font-weight: bold;" *ngIf="bid.passengerStatus !== 'Accepted'">{{bid.passengerStatus}}</td>
        </tr>
        <tr *ngIf="idx % 2 === 0" class="even">
          <td>{{bid.driverName}}</td>
          <td>{{bid.companyName}}</td>
          <td>{{bid.bidAmountStr}}</td>
          <td>{{bid.requestAssignedAt | datetimeformat}}</td>
          <td style="color:green;font-weight: bold;" *ngIf="bid.driverStatusStr === 'Accepted'">{{bid.driverStatusStr}}</td>
          <td style="color:red;font-weight: bold;" *ngIf="bid.driverStatusStr !== 'Accepted'">{{bid.driverStatusStr}}</td>
          <td style="color:green;font-weight: bold;" *ngIf="bid.passengerStatus === 'Accepted'">{{bid.passengerStatus}}</td>
          <td style="color:red;font-weight: bold;" *ngIf="bid.passengerStatus !== 'Accepted'">{{bid.passengerStatus}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="col-12 md:col-12 lg:col-12 panel-div booking-detail-container c-mt-10 c-box-shadow">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12">
        <div class="col-12 md:col-12 lg:col-12 header">
          <span translate>label_activity_logs</span>
        </div>
        @if (tourStatusActionLogs.length > 0) {
        <div class="col-12 md:col-12 lg:col-12 c-pl-37">
          @for (tourLog of tourStatusActionLogs; track $index) {
          <div class="grid">
            <div class="col-fixed  c-w-150 c-text-lightGrayColor">
              {{ tourLog.currentTourStatusString }}
            </div>
            <div class="col-fixed c-w-250">
              <span>{{ tourLog.actionTakenAtStr }}</span> <label class="c-px-8">by</label>
              <span>{{ tourLog.actionTakenByName }} ({{tourLog.actionTakenByRole}})</span>
            </div>
            <div class="col">
              @if (tourLog?.actionTakenOnAddress) {
              <span>{{ tourLog.actionTakenOnAddress }}</span>
              @if (tourLog.latitude && tourLog.longitude) {
              <span class="c-px-4">, ({{ tourLog.latitude }} {{ tourLog.longitude }})</span>
              }
              } @else {
              <span translate>label_no_address_found</span>
              }
            </div>
          </div>
          }
        </div>
        }
        @else {
        <div class="col-12 md:col-12 lg:col-12 c-pl-37">
          <div class="grid">
            <div class="max-heigh-50 col-12 md:col-12 lg:col-12  flex justify-content-center align-items-center c-text-lightGrayColor"
              translate>
              label_no_activity_logs</div>
          </div>
        </div>
        }
      </div>
    </div>

  </div>
  
</div>

<p-toast key="message"></p-toast>